
import { WorldCountry } from './types';

export const iranData: WorldCountry = {
  code: 'IR',
  name: 'Iran',
  slug: 'iran',
  population: 84923314,
  topCities: [
    { name: 'Tehran', slug: 'tehran', population: 9259009 },
    { name: 'Mashhad', slug: 'mashhad', population: 3372660 },
    { name: 'Isfahan', slug: 'isfahan', population: 2220000 },
    { name: 'Shiraz', slug: 'shiraz', population: 1869001 },
    { name: 'Tabriz', slug: 'tabriz', population: 1773033 },
    { name: 'Karaj', slug: 'karaj', population: 1613895 },
    { name: 'Qom', slug: 'qom', population: 1292283 },
    { name: 'Ahvaz', slug: 'ahvaz', population: 1184788 },
    { name: 'Kermanshah', slug: 'kermanshah', population: 946681 },
    { name: 'Urmia', slug: 'urmia', population: 736224 }
  ]
};
